import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Wind, Snowflake, Droplets, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const ServicesSection = () => {
  const services = [
    {
      icon: Wrench,
      title: 'Handyman',
      description: 'General repairs, maintenance, and property upkeep delivered with care and precision.',
      image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxtYWludGVuYW5jZXxlbnwwfHx8fDE3NzU3ODA2NDN8MA&ixlib=rb-4.1.0&q=85',
      href: '/services/handyman',
    },
    {
      icon: Wind,
      title: 'Air Conditioning',
      description: 'Installation, servicing, maintenance, and emergency repairs for reliable climate control.',
      image: 'https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxodmFjfGVufDB8fHx8MTc3NTc4MDYzMHww&ixlib=rb-4.1.0&q=85',
      href: '/services/air-conditioning',
    },
    {
      icon: Snowflake,
      title: 'Refrigeration',
      description: 'Expert support for commercial and domestic refrigeration systems, including breakdown response.',
      image: 'https://images.pexels.com/photos/7937299/pexels-photo-7937299.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      href: '/services/refrigeration',
    },
    {
      icon: Droplets,
      title: 'Plumbing',
      description: 'From urgent repairs to planned installations, we provide dependable plumbing solutions.',
      image: 'https://images.unsplash.com/photo-1676210133055-eab6ef033ce3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxwbHVtYmluZ3xlbnwwfHx8fDE3NzU3ODA2Mzl8MA&ixlib=rb-4.1.0&q=85',
      href: '/services/plumbing',
    },
  ];

  return (
    <section id="services" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What We Do
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Comprehensive engineering services delivered with precision and reliability
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <Card
              key={service.title}
              className="bg-gray-800/50 border-gray-700 hover:border-amber-600/50 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/10 group overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent"></div>
              </div>
              <CardHeader>
                <div className="flex items-center space-x-3 mb-2">
                  <div className="p-3 bg-amber-600/20 rounded-lg">
                    <service.icon className="w-6 h-6 text-amber-500" />
                  </div>
                  <CardTitle className="text-2xl text-white">{service.title}</CardTitle>
                </div>
                <CardDescription className="text-gray-300 text-base leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Button
                  asChild
                  variant="ghost"
                  className="text-amber-500 hover:text-amber-400 hover:bg-amber-600/10 group/btn p-0"
                >
                  <Link to={service.href} data-testid={`learn-more-${service.title.toLowerCase().replace(/\s+/g, '-')}`}>
                    Learn More
                    <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
